import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { showErrorMessage } from '../../notifications';
import { push } from 'connected-react-router';
import { fetchWhoAmI } from '../../auth/login.thunks';

export const confirmPayment: AsyncThunk<
  void,
  void,
  ThunkAPI
> = createAsyncThunk(
  'user/confirmPayment',
  async (data, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, void>({
        endpoint: 'accounts/confirm-payment',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post
      })(undefined, thunk);
      await thunk.dispatch(fetchWhoAmI());
      thunk.dispatch(push('/signUp/account-creation'));
      return response;
    } catch (error) {
      thunk.dispatch(showErrorMessage(JSON.stringify(error)));
      return thunk.rejectWithValue(error);
    }
  }
);